import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../modal/modal.service';
import { BehaviorSubject } from 'rxjs';
import { WINDOW } from '../../Services/window/window.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImageLoaderService {

  private imagesArray: string[] = [];
  private successCount = 0;
  // public allLoaded: boolean = false;
  public allLoaded = new BehaviorSubject(false);
  private cachedTripObject;
  private isCachedTrip = false;
  private cachedTripImagesLoaded = false;
  private tripImagesLoaded = false;
  private promiseResolver;

  constructor(
    private modalService: ModalService,
    private router: Router,
    @Inject(WINDOW) private window: Window,
  ) { }

  init(tripObject) {
    return new Promise ((resolve, reject) => {
      {
        this.isCachedTrip = false;
        this.imagesArray = [];
        this.successCount = 0;
        this.promiseResolver = resolve;
        this.collectNeededImagesToLoad(tripObject);
      }
    });
  }

  collectNeededImagesToLoad(tripObject) {
    // required images before loading screen:
    // destination image
    // accommodation image [0]
    // activity image [0]
    // extra destination images //removed
    // this.imagesArray.push(tripObject.data.travel.destination.thumbnail.image_url);
    // this.imagesArray.push(tripObject.data.travel.destination.thumbnail.image_url.replace('.webp', '.jpg'));
    // if(tripObject.data.travel.destination.destination_images.length > 0) {
    //   for(let i =0; i < tripObject.data.travel.destination.destination_images.length; i++) {
    //     this.imagesArray.push(tripObject.data.travel.destination.destination_images[i]);
    //   }
    // }
    this.isCachedTrip = tripObject.cachedTrip ? tripObject.cachedTrip : false;
    if (!this.isCachedTrip) {
      // this.allLoaded.next(false);
      this.tripImagesLoaded = false;
    }
    this.imagesArray.push(this.generateImageUrl(tripObject.data.travel.destination.thumbnail.image_url, 'main', false));
    this.imagesArray.push(this.generateImageUrl(tripObject.data.travel.destination.thumbnail.image_url, 'main', true));
    this.imagesArray.push(this.generateImageUrl(tripObject.data.travel.destination.thumbnail.image_url, 'thumb', false));
    this.imagesArray.push(tripObject.data.accommodations[0].hotel_object.hotel_photos ?
      (tripObject.data.accommodations[0].hotel_object.hotel_photos[0].url_max1024x768 ?
        tripObject.data.accommodations[0].hotel_object.hotel_photos[0].url_max1024x768 :
        tripObject.data.accommodations[0].hotel_object.hotel_photos[0].url_original) :
      'https://api.luckytrip.co.uk/images/accommodation_default.png');
    this.imagesArray.push(this.generateImageUrl(tripObject.data.activities[0].thumbnail.image_url, 'sub', false));
    this.imagesArray.push(this.generateImageUrl(tripObject.data.activities[0].thumbnail.image_url, 'sub', true));
    this.imagesArray.push(this.generateImageUrl(tripObject.data.activities[0].thumbnail.image_url, 'thumb', false));
    this.loadImages();
  }

  loadImages() {
    this.imagesArray.forEach(img => {
      const image = new Image();
      image.onload = this.onLoadSuccess.bind(this);
      image.onerror = this.ImageLoadError.bind(this);
      image.src = img;
    });
  }

  onLoadSuccess() {
    this.successCount ++;
    if (this.successCount === this.imagesArray.length) {
      if (!this.isCachedTrip) {
        this.allLoaded.next(false);
      }
      // if (!this.isCachedTrip) {
        this.allImagesLoaded();
      // }
    }
  }

  ImageLoadError() {
    this.onLoadSuccess();
  }

  allImagesLoaded() {
    this.allLoaded.next(true);
    if (this.isCachedTrip) {
      this.cachedTripImagesLoaded = true;
    } else {
      this.tripImagesLoaded = true;
      // setTimeout(() => {
      //   const activityIndicatorDomElement = <HTMLElement>document.getElementById('activityIndicatorElement');
      //   if (activityIndicatorDomElement) {
      //     this.modalService.destroy();
      //   }
      // }, 500);
      // !this.isCachedTrip &&
      // if (this.router.url.indexOf('/trips') < 0) {
      //   this.router.navigate(['/trips']);
      // }
    }
    // if (!this.isCachedTrip) {
      this.promiseResolver();
    // }
    if (this.cachedTripObject) {
      this.prepareCachedTripImages();
    }
  }

  cancelHiddenImage() {
    this.allLoaded.next(true);
  }

  closeActivityIndicator() {
    return new Promise ( (resolve, reject) => {
      {
        if (this.cachedTripImagesLoaded) {
          setTimeout(() => {
            if (this.router.url.indexOf('/trips') < 0) {
              // this.router.navigate(['/trips']);
              (this.window as any).location.replace(`${environment.metaUrl}trips`)
            }
            resolve();
          }, 700);
        }
      }
    });
  }

  generateImageUrl(url, type, fallback?) {
    if (!url) {
      return;
    }
    if (url && url.indexOf('/2048/') < 0) {
      return url;
    }
    let _url = url;
    if (fallback) {
      _url = url.replace('.webp', '.jpg');
    }
    switch (type) {
      case 'main':
        // do nothing return 2048 image
        break;
      case 'sub':
        _url = _url.replace('/2048/', '/1080/');
        break;
      case 'thumb':
        _url = url.replace('.webp', '.jpg');
        _url = _url.replace('/2048/', '/thumbnail/');
        break;
      case 'large':
        _url = _url.replace('/2048/', '/3840/');
        break;
      case 'medium':
        _url = _url.replace('/2048/', '/2048/');
        break;
      default:
        // do nothing return image URL as is
        break;
    }
    return _url;
  }

  cachedTripImages(tripObj) {
    if (tripObj.data) {
      this.cachedTripObject = tripObj;
      if (this.tripImagesLoaded) {
        this.prepareCachedTripImages();
      }
    }
  }

  prepareCachedTripImages() {
    if (this.cachedTripObject) {
      // this.isCachedTrip = true;
      this.cachedTripImagesLoaded = false;
      this.init(this.cachedTripObject);
      this.cachedTripObject = null;
    }
  }

}
